import React from 'react';


import Feedback from '../components/feedback-page/feedback-page.jsx';

class FeedbackComponents extends React.Component{
    constructor(){
        super()
    }
    
    render(){
        const {
            intl,
            setupdateProgress,
            setStateTrue,
            setStateFalse
        } = this.props
        return (
            <Feedback
                intl={intl}
                setupdateProgress = {setupdateProgress}
                setStateTrue = {setStateTrue}
                setStateFalse = {setStateFalse}
            />
        )
    }
}

export default FeedbackComponents